import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

import type { HubEntryId, TutorialProgress } from '@/features/tutorial/lib/tutorial-progress'
import type { TutorialId } from '@/features/tutorial/lib/tutorials'
import { STORAGE_KEYS } from '@/lib/configs/storage-config'
import { safeStorage } from '@/lib/safe-storage'

export interface TutorialRequest {
  id: TutorialId
  /**
   * Where it was opened from. `catalogue` and `hub` offer "Add to page" (the user is browsing
   * widgets); the others only explain. A plan-locked tutorial always shows the upgrade CTA.
   */
  source: 'widget' | 'catalogue' | 'upsell' | 'palette' | 'hub'
  /** The placed widget it's about, when opened from one: the tutorial then runs over it. */
  cardId?: string
  /** The step to open on (the hub's "Continue", or a step picked from its list). */
  step?: number
}

/** The open tutorial, or null. One dialog, mounted with the dashboard shell, reads it. */
export const tutorialRequestAtom = atom<TutorialRequest | null>(null)

/** Per-user acknowledged step counts. Legacy viewed indices leave the last step unfinished. */
export const tutorialProgressAtom = atomWithStorage<TutorialProgress>(
  STORAGE_KEYS.dashboard.tutorialProgress,
  {},
  safeStorage,
  { getOnInit: true }
)

/** The tutorials hub (every tutorial, with progress), opened from the header, palette, settings. */
export const tutorialHubOpenAtom = atom(false)

/** The entry the hub opens on (e.g. the tutorial just left for the list); read once on open. */
export const tutorialHubFocusAtom = atom<HubEntryId | null>(null)
